module.exports = __webpack_public_path__ + "img/bingo-tarjetas.444bf96b.png";